/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllResellerUsers } from '../fn/resellers/get-all-reseller-users';
import { GetAllResellerUsers$Params } from '../fn/resellers/get-all-reseller-users';
import { getReseller } from '../fn/resellers/get-reseller';
import { GetReseller$Params } from '../fn/resellers/get-reseller';
import { getResellers } from '../fn/resellers/get-resellers';
import { GetResellers$Params } from '../fn/resellers/get-resellers';
import { getResellerTenants } from '../fn/resellers/get-reseller-tenants';
import { GetResellerTenants$Params } from '../fn/resellers/get-reseller-tenants';
import { getResellerUsers } from '../fn/resellers/get-reseller-users';
import { GetResellerUsers$Params } from '../fn/resellers/get-reseller-users';
import { postReseller } from '../fn/resellers/post-reseller';
import { PostReseller$Params } from '../fn/resellers/post-reseller';
import { putReseller } from '../fn/resellers/put-reseller';
import { PutReseller$Params } from '../fn/resellers/put-reseller';
import { ResellerCollectionResponse } from '../models/reseller-collection-response';
import { ResellerMasterdata } from '../models/reseller-masterdata';
import { ResellerTenantProjectionResponse } from '../models/reseller-tenant-projection-response';
import { UsersResponse } from '../models/users-response';

@Injectable({ providedIn: 'root' })
export class ResellersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getResellers()` */
  static readonly GetResellersPath = '/resellers';

  /**
   * Get resellers.
   *
   * Get all the resellers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResellers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellers$Response(params?: GetResellers$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerCollectionResponse>> {
    return getResellers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get resellers.
   *
   * Get all the resellers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResellers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellers(params?: GetResellers$Params, context?: HttpContext): Observable<ResellerCollectionResponse> {
    return this.getResellers$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerCollectionResponse>): ResellerCollectionResponse => r.body)
    );
  }

  /** Path part for operation `postReseller()` */
  static readonly PostResellerPath = '/resellers';

  /**
   * Create a reseller.
   *
   * Create a reseller
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postReseller()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postReseller$Response(params: PostReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
    return postReseller(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a reseller.
   *
   * Create a reseller
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postReseller$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postReseller(params: PostReseller$Params, context?: HttpContext): Observable<ResellerMasterdata> {
    return this.postReseller$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerMasterdata>): ResellerMasterdata => r.body)
    );
  }

  /** Path part for operation `getAllResellerUsers()` */
  static readonly GetAllResellerUsersPath = '/resellers/users';

  /**
   * Search reseller users by match criteria.
   *
   * Get all users associated with reseller
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllResellerUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllResellerUsers$Response(params?: GetAllResellerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersResponse>> {
    return getAllResellerUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Search reseller users by match criteria.
   *
   * Get all users associated with reseller
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllResellerUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllResellerUsers(params?: GetAllResellerUsers$Params, context?: HttpContext): Observable<UsersResponse> {
    return this.getAllResellerUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersResponse>): UsersResponse => r.body)
    );
  }

  /** Path part for operation `getReseller()` */
  static readonly GetResellerPath = '/resellers/{resellerId}';

  /**
   * Get a reseller.
   *
   * Get a reseller by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReseller()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReseller$Response(params: GetReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
    return getReseller(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a reseller.
   *
   * Get a reseller by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReseller$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReseller(params: GetReseller$Params, context?: HttpContext): Observable<ResellerMasterdata> {
    return this.getReseller$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerMasterdata>): ResellerMasterdata => r.body)
    );
  }

  /** Path part for operation `putReseller()` */
  static readonly PutResellerPath = '/resellers/{resellerId}';

  /**
   * Update a reseller.
   *
   * Update a reseller by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putReseller()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putReseller$Response(params: PutReseller$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerMasterdata>> {
    return putReseller(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a reseller.
   *
   * Update a reseller by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putReseller$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putReseller(params: PutReseller$Params, context?: HttpContext): Observable<ResellerMasterdata> {
    return this.putReseller$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerMasterdata>): ResellerMasterdata => r.body)
    );
  }

  /** Path part for operation `getResellerTenants()` */
  static readonly GetResellerTenantsPath = '/resellers/{resellerId}/tenants';

  /**
   * Get tenants created by reseller.
   *
   * Get tenants created by reseller
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResellerTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellerTenants$Response(params: GetResellerTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerTenantProjectionResponse>> {
    return getResellerTenants(this.http, this.rootUrl, params, context);
  }

  /**
   * Get tenants created by reseller.
   *
   * Get tenants created by reseller
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResellerTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellerTenants(params: GetResellerTenants$Params, context?: HttpContext): Observable<ResellerTenantProjectionResponse> {
    return this.getResellerTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerTenantProjectionResponse>): ResellerTenantProjectionResponse => r.body)
    );
  }

  /** Path part for operation `getResellerUsers()` */
  static readonly GetResellerUsersPath = '/resellers/{resellerId}/users';

  /**
   * Get users associated with reseller.
   *
   * Get users associated with reseller
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getResellerUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellerUsers$Response(params: GetResellerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerTenantProjectionResponse>> {
    return getResellerUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get users associated with reseller.
   *
   * Get users associated with reseller
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getResellerUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getResellerUsers(params: GetResellerUsers$Params, context?: HttpContext): Observable<ResellerTenantProjectionResponse> {
    return this.getResellerUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResellerTenantProjectionResponse>): ResellerTenantProjectionResponse => r.body)
    );
  }

  /**
   * Search reseller users with filters using `/resellers/users` endpoint.
   * Note: explicitly sends empty Active-Tenant-Identifier header to avoid brand context.
   */
  getResellersUsersList(params: {
    firstName?: string;
    lastName?: string;
    external?: boolean;
    email?: string;
    phoneNumber?: string;
    status?: 'active' | 'invited' | 'disabled';
    roleId?: string;
    resellerId?: string;
    size?: number;
    start?: string;
    sortField?: string;
    sortDir?: 'asc' | 'desc';
  }): Observable<any> {
    const headers = new HttpHeaders({ 'Active-Tenant-Identifier': '' });
    const query: any = {};
    Object.keys(params || {}).forEach((k) => {
      const v = (params as any)[k];
      if (v !== undefined && v !== null && v !== '') query[k] = v;
    });
    return this.http
      .get(`${this.rootUrl}/resellers/users`, { params: query, headers })
      .pipe(map((r: any) => r));
  }
}
